class SiteFooter extends HTMLElement {
    connectedCallback() {
        // Get the "location" aka which handbook we're looking at.
        const location = window.getHandbookLocation();
        const year = new Date().getFullYear();
        // Define Main Handbook Footer HTML
        const handbookFooterHtml = /*html */ `
<footer class="footer">
  <div class="footer__container footer__container--flex">
    <div class="footer__links footer__links--contact">
      <div class="logo logo--footer">
        <a href="https://uiowa.edu">
          <div class="element-invisible">University of Iowa</div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="logo-icon"
            aria-labelledby="logo-footer"
            role="img"
            viewBox="0 0 311.6 90.2"
          >
            <path
              class="st0"
              d="M40 18.8h-7.3v52.4H40v19H0v-19h7.3V18.8H0V0h40V18.8z"
            ></path>
            <path
              class="st0"
              d="M93.8 90.2h-29c-10.5 0-17.4-6.9-17.4-18.2V18.2C47.4 7 54.4 0 64.8 0h29c10.5 0 17.4 7 17.4 18.2V72C111.2 83.2 104.2 90.2 93.8 90.2zM85.6 71.2V18.8H73v52.4H85.6z"
            ></path>
            <path
              class="st0"
              d="M122.6 18.8h-6.4V0h38v18.9H147l6.5 43.4L167 0h19.2l14.4 62.3 5.2-43.4h-6.6V0h37.5v18.9h-6.2l-11.3 71.4h-30.6l-11.8-53.2 -12.1 53.1h-29.4L122.6 18.8z"
            ></path>
            <path
              class="st0"
              d="M230.1 71.2h6.9L250.7 0h41l13.5 71.2h6.4v19H281l-2.9-22h-15.2l-2.7 22h-30L230.1 71.2 230.1 71.2zM276.5 51.7l-5.8-36.4 -6 36.4H276.5z"
            ></path>
            <image src="../../assets/images/uiowa-primary.png">
              <title id="logo-footer">University of Iowa</title>
            </image>
          </svg>
        </a>
      </div>
      <div class="site-name"><a href="/path_handbook">Laboratory Services Handbook</a></div>
      <div class="parent-site-name"><a href="https://pathology.medicine.uiowa.edu">Department of Pathology</a></div>
      <div class="footer__links footer__links--icon">
        <p>
          200 Hawkins Drive<br />Iowa City, IA 52242
          <br />
  
           <a href="/path_handbook/phone_nos.html"><span class="fa-phone fas" role="presentation"></span>Laboratory Phone Numbers</a>
   
          <br />
          <a href="/path_handbook/lab_directory.html">
            <span class="fa-book-open fas" role="presentation"></span>Lab Directory
          </a>
          <br />
         
          <br />
          <a href="/path_handbook/map_path_labs.pdf"><span class="fa-location-dot fas" role="presentation"></span>Clinical Laboratories Map</a>
 
        </li>
        </p>

        <nav role="navigation">
          <ul class="menu">
            <li>
              <a href="https://www.instagram.com/uiowapathology/">
                <i class="fab fa-instagram"></i>
                <span class="link-text">Instagram</span>
              </a>
            </li>

            <li>
              <a href="https://www.facebook.com/UIPathology/">
                <i class="fab fa-facebook"></i>
                <span class="link-text">Facebook</span>
              </a>
            </li>

            <li>
              <a href="https://bsky.app/profile/uipathology.bsky.social">
                <i class="fab fa-bluesky"></i>
                <span class="link-text">Bluesky</span>
              </a>
            </li>

            <li>
              <a href="https://x.com/UIPathology">
                <i class="fab fa-x-twitter"></i>
                <span class="link-text">X</span>
              </a>
            </li>

          </ul>
        </nav>
      </div>
      
      <!---->
      <div class="socket">
        <ul class="socket__menu">
          <li>© ${year} The University of Iowa</li>
          <li><a href="https://uiowa.edu/privacy">Privacy Notice</a></li>
          <li>
            <a
              href="https://opsmanual.uiowa.edu/community-policies/nondiscrimination-statement"
            >
              UI Nondiscrimination Statement
            </a>
          </li>
          <li><a href="https://accessibility.uiowa.edu/">Accessibility</a></li>
        </ul>
      </div>
    </div>

    
     <nav role="navigation" aria-labelledby="block-uids-base-footerprimary-menu" id="block-uids-base-footerprimary" class="footer__links footer__links--nav block block-menu navigation menu--footer-primary">
      <h2 class="visually-hidden" id="block-uids-base-footerprimary-menu">Footer primary</h2>

      <ul class="menu">
        <li class="menu-item menu-item--active-trail">
          <a href="/path_handbook/">Home</a>
        </li>
        <li class="menu-item">
          <a href="https://pathology.medicine.uiowa.edu/about-us/licensure-certifications-and-accreditations">Licensure</a>
        </li>
        <li class="menu-item">
          <a href="/path_handbook/appendix.html" data-drupal-link-system-path="node/566">Additional Info</a>
        </li>
      </ul>
    </nav>
    <nav role="navigation" aria-labelledby="block-uids-base-footersecondary-menu" id="block-uids-base-footersecondary" class="footer__links footer__links--nav block block-menu navigation menu--footer-secondary">
      <h2 class="visually-hidden" id="block-uids-base-footersecondary-menu">Footer secondary</h2>

      <ul class="menu">
        <li class="menu-item">
          <a href="/path_handbook/lab_bulletins/index.html">Lab Bulletins</a>
        </li>
        <li class="menu-item">
          <a href="/path_handbook/Appendix/Common/UN_CRIT_LAB_VAL.html">Critical Lab Tests &amp; Values</a>
        </li>
      </ul>
    </nav>
    <nav role="navigation" aria-labelledby="block-uids-base-footer-tertiary-menu" id="block-uids-base-footer-tertiary" class="footer__links footer__links--nav block block-menu navigation menu--footer-tertiary">
      <h2 class="visually-hidden" id="block-uids-base-footer-tertiary-menu">Footer tertiary</h2>

      <ul class="menu">
        <li class="menu-item">
          <a href="https://pathology.medicine.uiowa.edu/news-events">News &amp; Events</a>
        </li>
        <li class="menu-item">
          <a href="https://pathology.medicine.uiowa.edu/about-us/join-our-team">Join Our Team</a>
        </li>
      </ul>
    </nav>
  </div>
</footer>`;

        // Define UIDL Footer HTML
        const uidlFooterHtml = /*html */ `
    <footer class="footer">
  <div class="footer__container footer__container--flex">
    <div class="footer__links footer__links--contact">
      <div class="logo logo--footer">
        <a href="https://uiowa.edu">
          <div class="element-invisible">The University of Iowa</div>
          <svg xmlns="http://www.w3.org/2000/svg" class="logo-icon" aria-labelledby="logo-footer" role="img" viewBox="0 0 311.6 90.2">
            <path class="st0" d="M40 18.8h-7.3v52.4H40v19H0v-19h7.3V18.8H0V0h40V18.8z"></path>
            <path class="st0" d="M93.8 90.2h-29c-10.5 0-17.4-6.9-17.4-18.2V18.2C47.4 7 54.4 0 64.8 0h29c10.5 0 17.4 7 17.4 18.2V72C111.2 83.2 104.2 90.2 93.8 90.2zM85.6 71.2V18.8H73v52.4H85.6z"></path>
            <path class="st0" d="M122.6 18.8h-6.4V0h38v18.9H147l6.5 43.4L167 0h19.2l14.4 62.3 5.2-43.4h-6.6V0h37.5v18.9h-6.2l-11.3 71.4h-30.6l-11.8-53.2 -12.1 53.1h-29.4L122.6 18.8z"></path>
            <path class="st0" d="M230.1 71.2h6.9L250.7 0h41l13.5 71.2h6.4v19H281l-2.9-22h-15.2l-2.7 22h-30L230.1 71.2 230.1 71.2zM276.5 51.7l-5.8-36.4 -6 36.4H276.5z"></path>
            <image src="/themes/custom/uids_base/uids/assets/images/uiowa-primary.png">
              <title id="logo-footer">University of Iowa</title>
            </image>
          </svg>
        </a>
      </div>

      <a class="site-name-link" href="https://uidl.medicine.uiowa.edu">
        <h2 class="site-name">University of Iowa Diagnostic Laboratories (UIDL)</h2>
      </a>

      <strong class="parent-site-name">
        <a href="https://medicine.uiowa.edu"> Carver College of Medicine </a>
      </strong>

      <div class="region region-footer-first">
        <div id="block-uids-base-footercontactinfo--2" class="block block-block-content block-block-content0c0c1f36-3804-48b0-b384-6284eed8c67e">
          <p>
            Department of Pathology<br />
            200 Hawkins Drive<br />
            5231 Roy J. Carver Pavilion (RCP)<br />
            Iowa City, IA 52242-1087
          </p>
          <p>
            <a href="/node/51" data-entity-type="node" data-entity-uuid="26f2cb02-fdd8-4f19-bb76-b67701d343a8" data-entity-substitution="canonical"
              >Contact &amp; Availability
              <span class="fa-arrow-right"
                ><span class="fontawesome-icon-inline"><span class="fa-solid fa-arrow-right">&nbsp;</span></span></span
              ></a
            >
          </p>
          <p>
            Client Services:<br />
            <span class="fa-phone"
              ><span class="fontawesome-icon-inline"><span class="fas fa-phone">&nbsp;</span></span></span
            >
            <a href="tel:1-866-844-2522">1-866-844-2522</a> (toll-free)<br />
            <span class="fa-phone"
              ><span class="fontawesome-icon-inline"><span class="fa-phone fas">&nbsp;</span></span></span
            >
            <a href="tel:1-319-384-7212">1-319-384-7212</a> (local)<br />
            <span class="fa-envelope"
              ><span class="fontawesome-icon-inline"><span class="fa-envelope fas">&nbsp;</span></span></span
            >
            <a href="mailto:UIDLClientServices@healthcare.uiowa.edu">UIDLClientServices@healthcare.uiowa.edu</a><br />
            <span class="fa-fax"
              ><span class="fontawesome-icon-inline"><span class="fa-fax fas">&nbsp;</span></span></span
            >
            1-319-384-7213 (fax)
          </p>
          <p>
            Billing:<br />
            <span class="fa-phone"
              ><span class="fontawesome-icon-inline"><span class="fa-phone fas">&nbsp;</span></span></span
            >
            <a href="tel:1-319-353-7958">1-319-353-7958</a><br />
            <span class="fa-envelope"
              ><span class="fontawesome-icon-inline"><span class="fa-envelope fas">&nbsp;</span></span></span
            >
            <a href="mailto:UIDL-Billing@uiowa.edu">UIDL-Billing@uiowa.edu</a><br />
            <span class="fa-fax"
              ><span class="fontawesome-icon-inline"><span class="fa-fax fas">&nbsp;</span></span></span
            >
            1-319-356-0729 (fax)
          </p>
          <p>
            Courier Services:<br />
            <span class="fa-envelope"
              ><span class="fontawesome-icon-inline"><span class="fa-envelope fas">&nbsp;</span></span></span
            >
            <a href="mailto:uihc-courierservices@uiowa.edu">uihc-courierservices@healthcare.uiowa.edu</a>
          </p>
          <p><a href="mailto:pathwebmaster@healthcare.uiowa.edu">Report an issue with this page</a></p>
        </div>
      </div>
    </div>

    <nav role="navigation" aria-labelledby="block-uids-base-footerprimary-menu" id="block-uids-base-footerprimary" class="footer__links footer__links--nav block block-menu navigation menu--footer-primary">
      <h2 class="visually-hidden" id="block-uids-base-footerprimary-menu">Footer primary</h2>

      <ul class="menu">
        <li class="menu-item menu-item--active-trail">
          <a href="https://uidl.medicine.uiowa.edu/home" data-drupal-link-system-path="node/1" class="is-active" aria-current="page">Home</a>
        </li>
        <li class="menu-item">
          <a href="https://uidl.medicine.uiowa.edu/sending-case/fshd1-and-fshd2" data-drupal-link-system-path="node/246">FSHD1 &amp; FSHD2</a>
        </li>
        <li class="menu-item">
          <a href="https://uidl.medicine.uiowa.edu/client-resources" data-drupal-link-system-path="node/31">Client Resources</a>
        </li>
        <li class="menu-item">
          <a href="https://uidl.medicine.uiowa.edu/sending-case" data-drupal-link-system-path="node/36">Sending a Case</a>
        </li>
      </ul>
    </nav>
    <nav role="navigation" aria-labelledby="block-uids-base-footersecondary-menu" id="block-uids-base-footersecondary" class="footer__links footer__links--nav block block-menu navigation menu--footer-secondary">
      <h2 class="visually-hidden" id="block-uids-base-footersecondary-menu">Footer secondary</h2>

      <ul class="menu">
        <li class="menu-item">
          <a href="https://uidl.medicine.uiowa.edu/billing" data-drupal-link-system-path="node/71">Billing &amp; Payments</a>
        </li>
        <li class="menu-item">
          <a href="https://uidl.medicine.uiowa.edu/faculty-and-services" data-drupal-link-system-path="node/41">Faculty &amp; Services</a>
        </li>
        <li class="menu-item">
          <a href="https://www.healthcare.uiowa.edu/path_handbook/rindex.html">Test Directory</a>
        </li>
        <li class="menu-item">
          <a href="https://uidl.medicine.uiowa.edu/faculty-and-services/renal-pathology" data-drupal-link-system-path="node/141">Renal Pathology</a>
        </li>
      </ul>
    </nav>
    <nav role="navigation" aria-labelledby="block-uids-base-footer-tertiary-menu" id="block-uids-base-footer-tertiary" class="footer__links footer__links--nav block block-menu navigation menu--footer-tertiary">
      <h2 class="visually-hidden" id="block-uids-base-footer-tertiary-menu">Footer tertiary</h2>

      <ul class="menu">
        <li class="menu-item">
          <a href="https://uidl.medicine.uiowa.edu/about-us" data-drupal-link-system-path="node/206">About Us</a>
        </li>
        <li class="menu-item">
          <a href="https://uidl.medicine.uiowa.edu/about-us/contact-and-availability" data-drupal-link-system-path="node/206">Contact &amp; Availability</a>
        </li>
      </ul>
    </nav>
  </div>
  <div class="footer__container">
    <div class="socket">
      <ul class="socket__menu">
        <li>© ${year} The University of Iowa</li>
        <li>
          <a href="https://uiowa.edu/privacy">Privacy Notice</a>
        </li>
        <li>
          <a href="https://policy.uiowa.edu/community-policies/nondiscrimination-statement">UI Nondiscrimination Statement</a>
        </li>
        <li>
          <a href="https://accessibility.uiowa.edu/">Accessibility</a>
        </li>
      </ul>
    </div>
  </div>
</footer>


    `;

        // Define Off-Campus Footer HTML
        const ocFooterHtml = /*html */ `
       
        `;

        // Determine and use the appropriate footer based on the handbook we're looking at.
        switch (location) {
            case 1:
                this.innerHTML = handbookFooterHtml;
                break;
            case 2:
                this.innerHTML = ocFooterHtml;
                break;
            case 4:
                this.innerHTML = uidlFooterHtml;
                break;
            default:
                this.innerHTML = handbookFooterHtml;
                break;
        }
    }
}
customElements.define("site-footer", SiteFooter);
